var _cloneBuffer = {exports: {}};

export { _cloneBuffer as __module };
